import { useCallback, useEffect, useState } from "react";
import fetchStatus from "src/utils/api/fetch-status";

const useProfileApi = () => {
    const [state, setState] = useState({
        status: fetchStatus.PENDING,
        data: null,
    });

    const fetchFromApi = useCallback(async () => {
        try {
            await new Promise((r) => {
                setTimeout(r, 500);
            });
            const response = {};
            setState({
                status: fetchStatus.SUCCESS,
                data: response,
            });
        } catch (e) {
            setState({
                status: fetchStatus.ERROR,
                data: null,
            });
        }
    }, []);

    const fetchEffect = () => {
        fetchFromApi();
    };

    useEffect(fetchEffect, [fetchFromApi]);

    return {
        ...state,
        refetch: fetchFromApi,
    };
};

export default useProfileApi;
